import { Platform } from 'quasar'

/**
 * "Am I inside the desktop app?" — user-agent based (Platform.js), true even
 * if the preload failed to load. Use this for UI branching.
 */
export function isElectron () {
  return !!(Platform.is && Platform.is.electron === true)
}

/**
 * "Can I actually reach the main process?" — the real capability, requires
 * the contextBridge preload to have loaded.
 */
export function hasBridge () {
  return typeof window !== 'undefined' && !!window.electronAPI
}

// Desktop app with no bridge is the silent-dead-shell state the device
// checklist warns about. Say so once, loudly, here — rather than throwing a
// TypeError in whichever component happens to fire first.
function warnMissingBridge (action, channel) {
  if (isElectron()) {
    console.error(`electron bridge missing: ${action}("${channel}") ignored`)
  }
}

export function sendToMain (channel, ...args) {
  if (!hasBridge()) {
    warnMissingBridge('send', channel)
    return
  }
  window.electronAPI.send(channel, ...args)
}

export function onFromMain (channel, listener) {
  if (!hasBridge()) {
    warnMissingBridge('on', channel)
    return
  }
  window.electronAPI.on(channel, listener)
}

export function offFromMain (channel) {
  if (!hasBridge()) return
  window.electronAPI.off(channel)
}
